// App.jsx
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Sidebar from "./components/Sidebar/Sidebar";
import Home from "./components/HomePage/HomePage";
// import Employee from "./components/Employee/Employee";
import Header from "./components/Header/Header";
import AddDistrict from "./pages/District/District";
import DistrictList from "./pages/District/DistrictList";
import EditDistrict from "./pages/District/EditDistrict";
import DepartmentList from "./pages/Department/DepartmentList";
import DepartmentForm from "./pages/Department/DepartmentForm";
import AddBranch from "./pages/Branch/Branch";
import BranchList from "./pages/Branch/BranchList";
import AddHouseType from "./pages/HouseType/HouseType";
import HouseTypeList from "./pages/HouseType/HouseTypeList";
import EditHouseType from "./pages/HouseType/EditHouseType";
import AddZone from "./pages/Zone/Zone";
import ZoneList from "./pages/Zone/ZoneList";
import EditZone from "./pages/Zone/EditZone";
import AddCar from "./pages/Car/Car";
import CarList from "./pages/Car/CarList";
import EditCar from "./pages/Car/EditCar";
import Customers from "./pages/Customers/Customers";
import EditCustomer from "./pages/Customers/EditCustomer";
import Collections from "./pages/Collections/Collections";
import EditCollection from "./pages/Collections/EditCollection";
import Carmonitors from "./pages/Collections/Carmonitors";
import "./App.css";
import AddRole from "./pages/Role/Role";
import RoleList from "./pages/Role/RoleList";
import EditRole from "./pages/Role/EditRole";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.jsx/ProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
import Settings from "./pages/Settings/Settings";
// import UpdateUser from "./pages/users/UpdateUser";
import Register from "./pages/users/Register";
import Login from "./pages/users/Login";
// import EmployeeLists from "./pages/Settings/Employeelists";
import AddCompany from "./pages/Company/Company"
import CompanyList from "./pages/Company/CompanyList"
import EditCompany from "./pages/Company/EditCompany"
// import Payments from "./pages/Finance/Payments";
import EditBranch from "./pages/Branch/EditBranch";
import CollectorList from "./pages/Collector/CollectorList";
import Collector from "./pages/Collector/Collector";
import EditCollector from "./pages/Collector/EditCollector";
import CustomerPayments from "./pages/Finance/CustomerPaidments";
import EditCustomerPayments from "./pages/Finance/EditCustomerPaidments";





// Loading spinner
function LoadingSpinner() {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
}

// AppContent
function AppContent() {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  // haddii user aan login ahayn
  if (!currentUser) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // haddii user login yahay
  return (
    <div className="app-container">
      <Sidebar />
      <main className="main-content">
        <Header />
        <div className="content-wrapper">
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewRole"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <RoleList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddRole"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <AddRole />
                </ProtectedRoute>
              }
            />
            <Route
              path="/role/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <EditRole />
                </ProtectedRoute>
              }
            />
            
         


            <Route
              path="/AddDistrict"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddDistrict />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewDistrict"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <DistrictList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/district/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditDistrict />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddBranch"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddBranch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewBranch"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <BranchList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/branch/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditBranch />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddHouseType"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddHouseType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewHouseType"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <HouseTypeList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/housetype/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditHouseType />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddZone"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddZone />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewZone"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <ZoneList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/zone/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditZone />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddCar"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <AddCar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewCar"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <CarList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/car/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditCar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddCollector"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <Collector />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewCollector"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <CollectorList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/collectors/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer", "admin"]}>
                  <EditCollector />
                </ProtectedRoute>
              }
            />
<Route
  path="/CustomerPaidments"
  element={<ProtectedRoute requiredRole={["admin", "developer"]}><CustomerPayments /></ProtectedRoute>}
/>
<Route
  path="/CustomerPaidments/edit/:id"
  element={<ProtectedRoute requiredRole={["admin", "developer"]}><EditCustomerPayments /></ProtectedRoute>}
/>




           <Route
              path="/AddCompany"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <AddCompany />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewCompany"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <CompanyList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/company/edit/:id"
              element={
                <ProtectedRoute requiredRole={["developer"]}>
                  <EditCompany />
                </ProtectedRoute>
              }
            />
            <Route
              path="/departments"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <DepartmentList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/departments/add"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <DepartmentForm />
                </ProtectedRoute>
              }
            />


            <Route
              path="/departments/edit/:id"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <DepartmentForm />
                </ProtectedRoute>
              }
            />
            <Route path="/register" element={<ProtectedRoute requiredRole={["admin", "developer"]}>  <Register />
            </ProtectedRoute>} />


            <Route path="/settings" element={<ProtectedRoute requiredRole={["developer"]}> <Settings />  </ProtectedRoute>} />
        

            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Haddii user login yahay, hadduu isku dayo login/register → u dir home */}
            <Route path="/login" element={<Navigate to="/" replace />} />
            {/* <Route path="/register" element={<Navigate to="/" replace />} /> */}

            <Route path="*" element={<Navigate to="/" replace />} />
            <Route path="/Customers" element={<ProtectedRoute requiredRole={["admin", "finance", "developer"]}> <Customers />  </ProtectedRoute>} />
            <Route
              path="/Customers/edit/:id"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <EditCustomer />
                </ProtectedRoute>
              }
            />

            <Route path="/Collections" element={<ProtectedRoute requiredRole={["admin", "finance", "developer"]}> <Collections />  </ProtectedRoute>} />
            <Route
              path="/Collections/edit/:id"
              element={
                <ProtectedRoute requiredRole={["admin", "developer"]}>
                  <EditCollection />
                </ProtectedRoute>
              }
            />


            <Route path="/Carmonitors" element={<ProtectedRoute requiredRole={["admin", "finance", "developer"]}> <Carmonitors />  </ProtectedRoute>} />
           

          </Routes>
        </div>
      </main>
    </div>
  );
}

// App wrapper
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
